import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import About from "./Pages/About";
import CartView from "./Pages/CartView";
import SignIn from "./Pages/Auth/SignIn";
import Checkout from "./Pages/Checkout";
import SignUp from "./Pages/Auth/SignUp";
import TrackOrder from "./Pages/TrackOrder";
// import EventDetail from "./Pages/EventDetail";
// import EventPackages from "./Pages/EventPackages";
import Contact from "./Pages/Contact";
import Discount from "./Pages/Discount";
import Menu from "./Pages/Menu";
// import Dashboard from "./Pages/Dashboard";
import { Toaster } from "react-hot-toast";
import DashBoardLayout from "./Component/Dashboard/DashBoardLayout";
import PersonalInfo from "./Component/Dashboard/PersonalInfo";
import Layout from "./Component/Layout/Layout";
import Address from "./Component/Dashboard/Address";
import AddAddress from "./Component/Dashboard/AddAddress";
import EditAddress from "./Component/Dashboard/EditAddress";
import Order from "./Component/Dashboard/Order";
import OrderDetail from "./Component/Dashboard/OrderDetail";
import Wishlist from "./Component/Dashboard/WishList";
import Review from "./Component/Dashboard/Review";
import ChangePassword from "./Component/Dashboard/ChangePassword";
import { MenuDetail } from "./Pages/MenuDetail";
import ForgetEmail from "./Pages/Auth/ForgetEmail";
import ForgetPassword from "./Pages/Auth/ForgetPassword";
import OrderDecline from "./Pages/OrderDecline";
import OrderPlaced from "./Pages/OrderPlaced";

import ErrorPage from "./Pages/ErrorPage";
import PrivacyPOlicy from "./Pages/PrivacyPOlicy";
import TermsOfUse from "./Pages/TermsOfUse";
import ProductAndService from "./Pages/ProductAndService";
import Favourite from "./Pages/Favourite";
// import { useSelector } from "react-redux";
function App() {
  // const cartData = useSelector((state) => state.cart.cart);
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/cartview" element={<CartView />} />
          <Route path="/privacy-policy" element={<PrivacyPOlicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/product-and-service" element={<ProductAndService />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/trackorder" element={<TrackOrder />} />
          {/* <Route path="/eventdetail" element={<EventDetail />} /> */}
          {/* <Route path="/eventpackage" element={<EventPackages />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/discount" element={<Discount />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/favourite" element={<Favourite />} />
          <Route path="/menudetail/:id" element={<MenuDetail />} />
          <Route path="/orderdecline" element={<OrderDecline />} />
          <Route path="/orderplaced" element={<OrderPlaced />} />
          <Route
            path="/userprofile"
            element={
              <Layout>
                <DashBoardLayout>
                  <PersonalInfo />
                </DashBoardLayout>
              </Layout>
            }
          />
          <Route
            path="/saveaddress"
            element={
              <Layout>
                <DashBoardLayout>
                  <Address />
                </DashBoardLayout>
              </Layout>
            }
          />
          <Route
            path="/addaddress"
            element={
              <Layout>
                <DashBoardLayout>
                  <AddAddress />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route
            path="/editaddress"
            element={
              <Layout>
                <DashBoardLayout>
                  <EditAddress />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route
            path="/myorder"
            element={
              <Layout>
                <DashBoardLayout>
                  <Order />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route
            path="/myorderdetail"
            element={
              <Layout>
                <DashBoardLayout>
                  <OrderDetail />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route
            path="/myorderdetail"
            element={
              <Layout>
                <DashBoardLayout>
                  <OrderDetail />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route
            path="/wishlist"
            element={
              <Layout>
                <DashBoardLayout>
                  <Wishlist />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route
            path="/review"
            element={
              <Layout>
                <DashBoardLayout>
                  <Review />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route
            path="/changepassword"
            element={
              <Layout>
                <DashBoardLayout>
                  <ChangePassword />
                </DashBoardLayout>
              </Layout>
            }
          />

          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgetpassemail" element={<ForgetEmail />} />
          <Route path="/change-password" element={<ForgetPassword />} />
          <Route path="/*" element={<ErrorPage />} />
        </Routes>
      </Router>

      {/* <GoTop /> */}
    </>
  );
}

export default App;
